import React from 'react';
import { ExtendedInfoSVG } from '../../ExtendedInfo';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';
import { Icons } from '../../../../components/atoms/SVG';

type DownloadFileLinkIcon = {
  helpText: string;
};
export function DownloadFileLinkIcon({ helpText }: DownloadFileLinkIcon) {
  return (
    <div className="download__file-link-icon">
      <ExtendedInfoSVG helpText={helpText} tooltipPlacement={TooltipPlacement.TOP} svgSpriteID={Icons.CONNECTIONS} />
    </div>
  );
}
